import InnerHeader from '../components/InnerHeader';
import Meta from '../components/Meta';
import ServicesContent from "../components/ServicesContent";
import { Phone } from "lucide-react";

export default function IcbcBilling() {
  return (
    <div className="min-h-screen bg-white">
      <Meta />
      <InnerHeader
        title="ICBC Counselling Coverage in Surrey, BC"
        subtitle="Taking you on the path to recovery after accident"
        backgroundImage="/images/icbc-counselling-surrey.jpg"
      />

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex flex-col md:flex-row gap-8">
          {/* Left Column - Main Content */}
          <div className="flex-1">
            <section className="prose prose-lg max-w-4xl mx-auto mb-16">
              <div className="bg-white rounded-xl shadow-sm p-8 mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  ICBC Will Cover 12 Free Counselling Sessions 
                </h2>
                <p className="text-lg text-gray-600 mb-6">
                  Are you suffering physical and emotional pain from a Car Accident in BC? 
                  ICBC covers 12 free counselling sessions for you. The effects of accidents extend beyond physical scars to mental and emotional suffering. 

                  In the first three months of a car accident, you can get pre-approved counselling sessions, ICBC will cover 100% of the $140 visit for 12 sessions. Metro Counselling will bill ICBC directly.  You are matched with our expert ICBC Clinical Counsellors with over 15 years experience.

                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Understanding ICBC's No-Fault Insurance Model in British Columbia</h2>

                <p className="text-lg text-gray-600 mb-6">

                  As of May 1, 2021, the <a href="https://www.icbc.com/" target="_blank" rel="noopener noreferrer">Insurance Corporation of British Columbia (ICBC)</a> operates under a no-fault auto insurance system, known as <a href="https://www.icbc.com/insurance/Documents/your-guide-to-enhanced-care.pdf" target="_blank" rel="noopener noreferrer"></a>Enhanced Care coverage. Introduced through Bill 11 by the B.C. provincial legislature in 2020, this new model ensures that anyone injured in a car accident in British Columbia—regardless of who caused the collision—is eligible for financial compensation and medical recovery benefits. ICBC's no-fault insurance aims to deliver faster, more affordable, and more comprehensive support for accident victims, helping drivers and passengers recover quickly without the delays of fault-based claims.

                </p>
                <p className="text-xl font-semibold text-gray-800">
                  Count on us and end your inner battle with the impact of an accident.
                </p>
              </div>

              <div className="bg-gradient-to-br from-brand-teal/5 to-brand-teal/10 rounded-2xl p-8 mb-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">
                  Our ICBC Counselling Coverage
                </h3>
                <p className="text-gray-600 mb-4">
                  If you've been injured in a car accident, ICBC counselling services help with your mental health recovery. 
                  Our experienced team provides the following support:
                </p>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-brand-teal flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="ml-3 text-gray-600">Psychological assessments and treatments</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-brand-teal flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="ml-3 text-gray-600">Trauma counselling</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-brand-teal flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="ml-3 text-gray-600">Support for anxiety and depression</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-brand-teal flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="ml-3 text-gray-600">Recovery and rehabilitation planning</span>
                  </li>
                </ul>
              </div>

              <div className="mb-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">
                  Road to Recovery: Treatment Areas
                </h3>
                <p className="text-gray-600 mb-4">
                  Our ICBC Counselling services are designed to support you in navigating the emotional 
                  and mental challenges that arise following an accident.
                </p>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-brand-teal flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="ml-3 text-gray-600">Emotional Recovery After an Accident</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-brand-teal flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="ml-3 text-gray-600">Stress Management</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-brand-teal flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="ml-3 text-gray-600">Minimizing Anxiety while Driving</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-6 w-6 text-brand-teal flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="ml-3 text-gray-600">Building Self-Confidence to Get Back to Driving</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gradient-to-br from-brand-teal/5 to-brand-teal/10 rounded-2xl p-8 mb-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">
                  Hassle-Free ICBC Documentation Support
                </h3>
                <p className="text-gray-600 mb-4">
                  When you are already having a difficult time, having to deal with ICBC paperwork only adds to your stress. 
                  At Metro Counselling, we streamline the process to make it simple and hassle-free for you.
                </p>
                <p className="text-gray-600">
                  By handling all documents and other procedures with ICBC, we ensure that you can focus completely on recovering. 
                  Our team of professionals will handle the details so you can concentrate on healing and moving forward.
                </p>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-8 mb-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">
                  Our Comprehensive ICBC Counselling Services
                </h3>
                <div className="space-y-6">
                  <div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">Post-Accident Trauma Counselling</h4>
                    <p className="text-gray-600">Car accident trauma-focused therapy allows individuals to process and heal psychologically.</p>
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">Chronic Pain Management</h4>
                    <p className="text-gray-600">A combination of emotional support and counselling is provided to manage chronic pain caused by accidents.</p>
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">Grief and Loss Counselling</h4>
                    <p className="text-gray-600">Our grief counselling can help you deal with difficult emotions following an accident, whether you've lost mobility, your job, or a loved one.</p>
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">Stress Management</h4>
                    <p className="text-gray-600">Our stress management techniques improve mental health by relieving anxiety and building resilience.</p>
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">Life Changing Assistance</h4>
                    <p className="text-gray-600">Life transition counselling helps you adjust to new routines following an accident that has impacted your daily activities.</p>
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">Therapy for Anxiety from Accident</h4>
                    <p className="text-gray-600">Our graded exposure therapy helps people who feel heightened anxiety or fear when driving or being in a vehicle.</p>
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">Rehabilitation Counselling</h4>
                    <p className="text-gray-600">We assist individuals with returning to work through vocational guidance and job retraining, addressing any limitations from work-related accidents.</p>
                  </div>
                </div>
              </div>
            </section>
          </div>

          {/* Right Column - CTA Card */}
          <div className="md:w-80 lg:w-96">
            <div className="bg-white rounded-lg shadow-lg p-6 sticky top-24">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                Eliminate Your Stress from Accidents
              </h3>
              <p className="text-gray-600 mb-6">
                Don't let emotional wounds from an accident hold you back. Contact us today to book your 
                ICBC-covered counselling session and start your journey to recovery.
              </p>
              <a
                href="tel:604-619-9992"
                className="flex items-center justify-center gap-2 w-full bg-brand-teal hover:bg-brand-teal-dark text-white font-medium px-6 py-3 rounded-lg transition-colors"
              >
                <Phone className="h-5 w-5" />
                <span>604-619-9992</span>
              </a>
              <p className="text-sm text-gray-500 mt-4 text-center">
                ICBC-covered counselling services in Surrey, BC
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12">
          <ServicesContent />
        </div>
      </div>
    </div>
  );
}
